import { render, staticRenderFns } from "./kalemotel.vue?vue&type=template&id=92334f88&"
import script from "./kalemotel.vue?vue&type=script&lang=js&"
export * from "./kalemotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports